// Import utilities
const {
	isDefined
} = _uo.utility;

/**
 * Determines if the user can manage conditions
 *
 * @return {Boolean} True if the user can manage conditions
 */
const canManageConditions = () => {
	return isDefined( UncannyAutomator.wp ) && UncannyAutomator.wp;
};

export default canManageConditions;
